/* AsPadel — indicateur de stock bas sous le bouton d'achat.
   Il n'affiche un chiffre que s'il est vrai : stock suivi par Shopify, sans vente
   en surréservation. Sinon, il se tait. */
(function () {
  'use strict';

  function nombre(v, d) { var n = parseInt(v, 10); return isNaN(n) ? d : n; }

  /* Décision pure, testable sans page.
     variante : { q: quantité, s: stock suivi et sans surréservation } */
  function decider(variante, seuil, afficherOk) {
    if (!variante || !variante.s) return { mode: 'rien' };
    var q = variante.q;
    if (q <= 0) return { mode: 'rien' };
    if (q <= seuil) return { mode: 'bas', q: q, pct: Math.max(8, Math.min(100, Math.round((q / seuil) * 100))) };
    return afficherOk ? { mode: 'ok', q: q } : { mode: 'rien' };
  }

  function Stock(racine) {
    this.r = racine;
    this.seuil = Math.max(1, nombre(racine.dataset.seuil, 3));
    this.afficherOk = racine.dataset.ok === 'true';
    this.variantes = {};
    var json = racine.querySelector('[data-stock-variantes]');
    if (json) { try { this.variantes = JSON.parse(json.textContent); } catch (e) {} }
  }

  Stock.prototype.rendre = function (idVariante) {
    var r = this.r;
    var d = decider(this.variantes[idVariante], this.seuil, this.afficherOk);
    var texte = r.querySelector('[data-stock-texte]');
    var jauge = r.querySelector('[data-stock-jauge]');

    if (d.mode === 'rien') { r.hidden = true; return d; }
    r.hidden = false;
    r.classList.toggle('apstk--ok', d.mode === 'ok');
    r.classList.toggle('apstk--bas', d.mode === 'bas');

    if (texte) {
      if (d.mode === 'ok') {
        texte.textContent = r.dataset.texteOk || '';
      } else {
        var modele = d.q === 1 ? (r.dataset.texteUn || '') : (r.dataset.textePlusieurs || '');
        texte.textContent = modele.replace(/\{n\}/g, String(d.q));
      }
    }
    if (jauge) {
      jauge.style.width = (d.mode === 'bas' ? d.pct : 100) + '%';
    }
    return d;
  };

  function initialiser(racine) {
    if (racine.__apStock) return;
    var st = new Stock(racine);
    racine.__apStock = st;
    var select = document.querySelector('[data-variantes]');
    if (select) {
      select.addEventListener('change', function () { st.rendre(select.value); });
    }
    st.rendre(racine.dataset.variante);
  }

  function tout() { document.querySelectorAll('[data-stock]').forEach(initialiser); }

  window.AspadelStock = { decider: decider, Stock: Stock };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);
  document.addEventListener('shopify:block:select', tout);
})();
